import React, { memo } from 'react'

import { Icon, Upload2 } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import DesktopOnlyTooltip from 'Pods/Shared/DesktopOnlyTooltip/DesktopOnlyTooltip'
import { iconSizeNav } from 'Pods/ThreeDStudio/constants'
import useThreeDModelEntryPoint from 'Pods/ThreeDStudio/Hooks/useThreeDModelEntryPoint'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

// The collapsed rail counterpart of the library's "Use your 3D Model" card, sitting next
// to the collapsed generate card so the flow stays reachable with the sidebar closed.
function CollapsedUseModelCard() {
  const t = useTranslation()
  const { isLoading, onClick } = useThreeDModelEntryPoint()
  const label = t('shared.uploadModel.upload')

  return (
    <DesktopOnlyTooltip content={label} id="collapsed-use-model-card-tooltip" place="right">
      <button
        type="button"
        className="collapsed-model-status-card collapsed-model-status-card--use"
        onClick={!isLoading ? onClick : undefined}
        aria-label={label}
      >
        <Icon svgComponent={Upload2} size={iconSizeNav} color="dark" notSpaced />
      </button>
    </DesktopOnlyTooltip>
  )
}

export default memo(CollapsedUseModelCard)
